import React, {Component} from 'react'
import { TableRow,TableCell } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import SimpleTable from '../../../../../components/Tables/SimpleTable'
import {TableItem} from '../../../../../components/DisplayData/DisplayData'

import { green, red, grey, lightBlue, orange } from '@material-ui/core/colors';
import { onFormatNumber } from '../../../../../shared/utility'


const styles = (theme) => ({
  root:{},
  tablecell:{
    borderTop:`2px solid ${grey[200]}`,
    padding:'16px 16px',
    border:0,
    '&:hover':{
      cursor:'pointer'
    }
  },
  tablecell2:{
    maxWidth:200,
    borderTop:`2px solid ${grey[200]}`,
    padding:'16px 16px',
    border:0,
    '&:hover':{
      cursor:'pointer'
    }
  },
  tablerow:{
    '&:hover':{
      background:'rgba(0,0,0,0.05)'
    }
  }
})

class SpecialPatientList extends Component{

  state = {
    rowsPerPage:5,
    page:0,
    searchText:'',
  }

  handleChangeRowsPerPage = (event) => {
    const value = parseInt(event.target.value,10)
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    temp.page = 0
    temp.rowsPerPage = value
    onChangeConfig(temp)
  }

  handleChangePage = (event, newPage) => {
    //this.setState({page:newPage})
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    temp.page = newPage
    onChangeConfig(temp)
  }

  onSearch = (value) => {
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    temp.searchText = value
    onChangeConfig(temp)
  }

  onChangeFilter = (item) => {
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    temp.filter = item.id
    onChangeConfig(temp)

  }
  
  onChangeMasterFilter = (key, data) => {
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    Object.keys(temp.filter).forEach(item => {
      if(item === key){
        temp.filter[item] = data
      }else{
        temp.filter[item] = null
      }
    })
    temp.page = 0
    
    onChangeConfig(temp)

  }

  render(){

    const {classes, title, header, data, onUserSelected, onAddItem, 
      filters, config, master_filters, total_items
    } = this.props
    const { page, rowsPerPage, isSearch} = config
    return(
      
      <div className={classes.root}>
        <SimpleTable
          title={title}
          header={header}
          isSearch={isSearch}
          filter={config.filter}
          filters={filters}
          master_filters={master_filters}
          onChangeFilter={this.onChangeFilter}
          onChangeMasterFilter={this.onChangeMasterFilter}
          rowsPerPage={rowsPerPage}
          page={page}
          rows={total_items}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          onSearch={this.onSearch}
          addItem
          onAddItem={onAddItem}
        >
          {data.map((item,key)=>{
            return(
              <TableRow key={key.toString()} 
              className={classes.tablerow} 
              >
                <TableCell className={classes.tablecell} onClick={() => onUserSelected(item.id_patient)}>
                  <TableItem 
                    data={`SS${onFormatNumber(item.id_patient,6)}`}
                  />
                </TableCell>
                <TableCell className={classes.tablecell} onClick={() => onUserSelected(item.id_patient)}>
                  <TableItem 
                    data={item.name}
                  />
                </TableCell>
                <TableCell className={classes.tablecell} onClick={() => onUserSelected(item.id_patient)}>
                  <TableItem 
                    data={item.insurance_carrier}
                  />
                </TableCell>
                <TableCell className={classes.tablecell} onClick={() => onUserSelected(item.id_patient)}>
                  <TableItem 
                    data={item.nse}
                  />
                </TableCell>

                <TableCell className={classes.tablecell} onClick={() => onUserSelected(item.id_patient)}>
                  <TableItem 
                    icon='brightness_1'
                    iconSize={12}
                    iconColor={this.getApprovalStatusColor(item.approval_status_id)}
                    data={item.approval_status_id === 1 ? 'En proceso' : item.approval_status}
                  />
                </TableCell>
              </TableRow>
            )
          })}
        </SimpleTable>
      </div>
    )
  }

  getPatientStatusColor = (status) => {
    let color
    switch (status) {
      case 1:
        color = lightBlue[700]
        break;
      case 2:
        color = green[700]
        break;
      case 3:
        color = red[700]
        break;
      default:
          color = grey[500]
        break;
    }
    return color
  }

  getApprovalStatusColor = (status) => {
    let color
    switch (status) {
      case 1:
        color = grey[700]
        break;
      case 2:
        color = lightBlue[700]
        break;
      case 3:
        color = green[700]
        break;
      case 4:
          color = orange[700]
          break;
      case 5:
          color = red[700]
          break;
      default:
          color = grey[500]
        break;
    }
    return color
  }

  getLetterStatusColor = (status) => {
    let color
    switch (status) {
      case 1:
        color = red[700]
        break;
      case 2:
        color = lightBlue[700]
        break;
      case 3:
        color = green[700]
        break;
      default:
          color = grey[500]
        break;
    }
    return color
  }

  handleChangePage = (event, newPage) => {
    //this.setState({page:newPage})
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    temp.page = newPage
    onChangeConfig(temp)
  }

  onSearch = (value) => {
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    temp.searchText = value
    onChangeConfig(temp)
  }

  onChangeFilter = (item) => {
    const {config, onChangeConfig} = this.props
    let temp = {...config}
    temp.filter = item.id
    onChangeConfig(temp)

  }
}

export default withStyles(styles)(SpecialPatientList)